import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=8a451e26&"
import script from "./AuthLayout.vue?vue&type=script&lang=js&"
export * from "./AuthLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2640919926/src/minhaloja-v2-international/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a451e26')) {
      api.createRecord('8a451e26', component.options)
    } else {
      api.reload('8a451e26', component.options)
    }
    module.hot.accept("./AuthLayout.vue?vue&type=template&id=8a451e26&", function () {
      api.rerender('8a451e26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/AuthLayout.vue"
export default component.exports